// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__DBZet","consentsList":"PatientConsents_consentsList__2Ob8n","consentsListEmpty":"PatientConsents_consentsListEmpty__2W2ZF"};